import React, { useState } from "react";
import { Button } from "antd";
import { BookOutlined } from "@ant-design/icons";
import { FormItem, InputItem, TextAreaItem } from "./Items";
import SelectTiposAcumuladosItem from "./SelectTiposAcumuladosItem";
import GuiaFormulas from "../Pages/Panel/Conceptos/GuiaFormulas/GuiaFormulas";

/**
 * ImporteTab — reutilizable para cada tab de importe (Total, 1, 2, 3, 4).
 *
 * Props:
 *   prefix:        string  — "ImporTotal" | "Importe1" | ... (sufijo del nombre de campo)
 *   nombreField:   string  — nombre del field en el form. Ej: "nombreImporteTotal"
 *   formulaField:  string  — nombre del field de fórmula
 *   acumFiscField: string  — nombre del field de acumulados fiscales
 *   otrosAcumField:string  — nombre del field de otros acumulados
 *   required:      bool    — si el nombre y fórmula son requeridos
 *   formRef:       ref     — referencia al form para el SelectTiposAcumuladosItem
 *   headersToken:  object
 *   empresaId:     string
 */
const ImporteTab = ({
    nombreField,
    formulaField,
    acumFiscField,
    otrosAcumField,
    required,
    formRef,
    headersToken,
    empresaId,
}) => {
    // La guía se abre en un Drawer por encima del modal del concepto, para poder
    // consultar las variables sin perder lo que se está capturando.
    const [guiaVisible, setGuiaVisible] = useState(false);

    return (
        <div>
            <FormItem
                name={nombreField}
                label="Nombre"
                required={required}
                margin
            >
                <InputItem placeholder="Nombre del importe" />
            </FormItem>

            <FormItem
                name={formulaField}
                label="Fórmula"
                required={required}
                margin
                tooltip="Escribe la fórmula usando variables del sistema. Ej: SALARIO_DIARIO * DIAS_TRABAJADOS"
                extra={
                    <Button
                        type="link"
                        size="small"
                        icon={<BookOutlined />}
                        onClick={() => setGuiaVisible(true)}
                        style={{ padding: 0, fontSize: 12, height: "auto" }}
                    >
                        Ver guía de fórmulas: variables, funciones y ejemplos
                    </Button>
                }
            >
                <TextAreaItem
                    rows={10}
                    placeholder="Ej: SALARIO_DIARIO * DIAS_TRABAJADOS"
                    style={{ fontFamily: "monospace" }}
                />
            </FormItem>

            <FormItem
                name={acumFiscField}
                label="Acumulados Fiscales"
                margin
            >
                <SelectTiposAcumuladosItem
                    mode="multiple"
                    placeholder="Selecciona los tipos de acumulados fiscales"
                    empresaId={empresaId}
                    headersToken={headersToken}
                    onChange={(value) => {
                        formRef.current && formRef.current.setFieldsValue({ [acumFiscField]: value });
                    }}
                />
            </FormItem>

            <FormItem
                name={otrosAcumField}
                label="Otros Acumulados"
                margin
            >
                <SelectTiposAcumuladosItem
                    mode="multiple"
                    placeholder="Selecciona otros tipos de acumulados"
                    empresaId={empresaId}
                    headersToken={headersToken}
                    onChange={(value) => {
                        formRef.current && formRef.current.setFieldsValue({ [otrosAcumField]: value });
                    }}
                />
            </FormItem>

            <GuiaFormulas visible={guiaVisible} onClose={() => setGuiaVisible(false)} />
        </div>
    );
};

export default ImporteTab;
